import React, { useEffect } from 'react'
import { useHistory } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from '@material-ui/core'
import CloudDownload from '@material-ui/icons/CloudDownload'
import { withStyles } from '@material-ui/core/styles'
import invokeApi from './../../util/apiclient'
import download from './../../util/csv-download'
import { getUser } from '../../actions/users'
import Navigation from '../../components/navigation'
import PaymentOptions from '../../components/paymentOptions'

import './styles.css'

const styles = theme => ({
  rightIcon: {
    marginLeft: theme.spacing(1),
  }
})

const Dashboard = (props) => {
  const myUserId = useSelector(state => state.cognito.userId)
  const user = useSelector(state => (state.users.list || {})[myUserId])

  const dispatch = useDispatch()
  const history = useHistory()

  // load user data
  useEffect(() => {
    getUser('me')(dispatch)
  }, [])

  // check user profile
  let completeUserInfo = null
  if (user && (user.firstName == null || user.lastName == null || user.email == null)) {
    completeUserInfo = (
      <div>
        <div className='alert alert-primary' role='alert'>
          We noticed your user profile is not yet completed. Take your time to fill in all the details.
          </div>
        <Button variant='contained' color='primary' onClick={() => history.push('/profile/me')}>Check Profile</Button>
      </div>)
  }

  // in case everything is okay
  let okayInfo = null
  if (completeUserInfo == null) {
    okayInfo = <div className='alert alert-primary' role='alert'>Everything looks great! <br />Use the hamburger menu icon in the top left to navigate your settings.</div>
  }

  let exportSection = null
  if (user && user.admin === true) {
    exportSection = (
      <div>
        <div className='alert alert-primary' role='alert'>
          <span style={{ marginRight: '20px' }}>It seems you have admin super powers!</span>
          <Button variant='contained' onClick={() => {
            invokeApi('GET', '/users/csv').then(response => {
              download(response.data, 'export.csv', 'text/csv')
            })
          }}>
            Export CSV
              <CloudDownload className={props.classes.rightIcon} />
          </Button>
        </div>
      </div>)
  }

  return (
    <div className='dashboard'>
      <Navigation title='Dashboard' />
      <div className='box'>
        <PaymentOptions />
        {completeUserInfo}
        {okayInfo}
        {exportSection}
      </div>
    </div>
  )
}

export default withStyles(styles)(Dashboard)
